import authRules from '../authRules.js';

const viewTourSalaryLevel = (user) => {
  const { updateSalaryLevelInApprovals } = user.securityLevels;
  if (updateSalaryLevelInApprovals >= authRules.viewTourSalaryLevel.updateSalaryLevelInApprovals) {
      return true;
  } else {
      return false;
    }
  }


export default viewTourSalaryLevel;